import React, { Component } from 'react';
import axios from '../../axios';
import qs from 'qs';
import Alert from 'react-s-alert'
import FormDropdown from '../../components/FormDropdown'
import FormDropdownWali from '../../components/FormDropdownWali'
import FormModalWali from '../../components/FormModalWali'
import FormModalKelas from '../../components/FormModalKelas'
import { status_aktif } from '../../constants/general'
import DatePicker from 'react-datepicker'
import { FOTO_SISWA_HOST } from '../../constants/siteConfig'
import { FOTO_WALI_HOST } from '../../constants/siteConfig'
import { dataLevel } from '../../constants/general'
import Dropzone from 'react-dropzone'
import FormsSiswa from './FormsSiswa'
import FormsWali from './FormsWali'
import FormsGuru from './FormsGuru'
import VerifikasiModal from '../../components/VerifikasiModal'
import moment from 'moment'
import queryString from 'query-string'
import Select from "react-select";

const jekel = [
	{key: "l", value: "Laki-laki"},
	{key: "p", value: "Perempuan"},
]

const selectForm = [
	{ key: "buka", value: "Tampilkan Form Wali" },
	{ key: "tutup", value: "Sembunyikan Form Wali" }
]

class Forms extends Component {
	constructor(props) {
		super(props)

		this.state = {
			user_id             : "",
			user_level          : "",
			user_nama           : "",
			user_foto           : "",
			user_username       : "",
			user_passw	        : "",
			user_status         : "",

			siswa_id            : "",
			kelas_id            : "",
			siswa_nama          : "",
			siswa_rfid			: "",
			siswa_nisn          : "",
			siswa_nis           : "",
			siswa_tahun         : "",
			siswa_provinsi      : "",
			siswa_kota          : "",
			siswa_alamat        : "",
			siswa_nohp          : "",
			siswa_gender        : "",
			siswa_tempat_lahir  : "",
			siswa_status        : "",
			siswa_foto          : "",
			siswa_foto_exist    : "",
			dataLevel 			: dataLevel,
			siswa_tanggal_lahir : moment().format('YYYY-MM-DD'),
			siswa_tanggal_lahir_moment : moment(),

			wali_id             : "",
			wali_nama           : "",
			wali_alamat         : "",
			wali_nohp           : "",
			wali_status         : "",
			wali_provinsi       : "",
			wali_kota           : "",
			wali_gender         : "",
			wali_tempat_lahir   : "",
			wali_tanggal_lahir  : moment().format('YYYY-MM-DD'),
			wali_tanggal_lahir_moment: moment(),
			wali_foto           : "",
			wali_foto_exist     : "",
			wali_siswa_id       : [],
			wali_siswa_nama     : [],
			wali_siswa_id_exist : [],
			wali_siswa_nama_exist: [],

			guru_id             : "",
			guru_nama           : "",
			guru_nip         	: "",
			guru_rfid           : "",
			selectedWali		: "tutup",

			dataWaliSiswa		: [],
			dataKelas			: [],

			invDate : "",

			isButtonLoading     : false,
			isLoading           : false,
            isModalVerifikasi  	: false,
			isModalWali		  	: false,
			isModalKelas		: false
		}

		this.handleChange           = this.handleChange.bind(this);
		this.toggleModalVerifikasi  = this.toggleModalVerifikasi.bind(this);
		this.toggleModalWali  		= this.toggleModalWali.bind(this);
		this.toggleModalKelas  		= this.toggleModalKelas.bind(this);
		this.handleChangeMultiSelect = this.handleChangeMultiSelect.bind(this);
		this.handleSubmit           = this.handleSubmit.bind(this);
		this.onDrop                 = this.onDrop.bind(this);
		this.handleDeleteFile       = this.handleDeleteFile.bind(this);
		this.handleChangeDatepicker = this.handleChangeDatepicker.bind(this);
		this.handleAddSiswaButton   = this.handleAddSiswaButton.bind(this);
		this.setParentState         = this.setParentState.bind(this);
	}

	handleChangeMultiSelect(stateName, text) {
		this.setState({
			[stateName]: text}
			);

			if(stateName == 'wali_id'){
				this.loadDataVerifikasiWali(text);
			}


	}
	handleChange(event) {

		const target = event.target;
		const value  = target.type === 'checkbox' ? target.checked : target.value;
		const name   = target.name;

		this.setState({
			[name]: value
		})
	}

	// handleChangeWali(event) {

	// 	const target = event.target;
	// 	const value  = target.type === 'checkbox' ? target.checked : target.value;
	// 	const name   = target.name;

	// 	this.setState({
	// 		[name]: value
	// 	},()=>{
	// 		if(name == 'selectedWali'){
	// 			this.toggleModalWali();

	// 		}
	// 	})
	// }

    toggleModalVerifikasi() {
        this.setState({ isModalVerifikasi: !this.state.isModalVerifikasi})
	}

    toggleModalWali() {
        this.setState({ isModalWali: !this.state.isModalWali})
	}

    toggleModalKelas() {
        this.setState({ isModalKelas: !this.state.isModalKelas})
	}


    loadDataVerifikasiWali(text) {

		this.setState({ isLoading: true })

        const params = qs.stringify({
            wali_id: text
        })

        axios.post("/wali_verifikasi?" + params)
            .then(response => {
                const result = response.data
				// alert(result.length)
				if(result.success){
					this.setState({
						dataWaliSiswa  : result.data,
						isLoading  : false
					},()=>{
						this. toggleModalVerifikasi();
					})
				}else{
					this.setState({
						dataWaliSiswa  : [],
						isLoading  : false
					},()=>{
						this. toggleModalVerifikasi();
					})
				}

            })
            .catch((error) => {

                console.log(error)

                this.setState({ isLoading: false })
            })
    }

	handleSubmitSiswa() {

		this.setState({ isButtonLoading: true })

		let formData = new FormData();


			formData.append('selectedWali', this.state.selectedWali)
			formData.append('siswa_id', this.state.siswa_id)
			formData.append('wali_id', this.state.wali_id)
			formData.append('user_id', this.state.user_id)
			formData.append('kelas_id', this.state.kelas_id)
			formData.append('siswa_rfid', this.state.siswa_rfid)
			formData.append('siswa_nama', this.state.siswa_nama)
			formData.append('siswa_nisn', this.state.siswa_nisn)
			formData.append('siswa_nis', this.state.siswa_nis)
			formData.append('siswa_tahun', this.state.siswa_tahun)
			formData.append('siswa_provinsi', this.state.siswa_provinsi)
			formData.append('siswa_kota', this.state.siswa_kota)
			formData.append('siswa_alamat', this.state.siswa_alamat)
			formData.append('siswa_nohp', this.state.siswa_nohp)
			formData.append('siswa_gender', this.state.siswa_gender)
			formData.append('siswa_tempat_lahir', this.state.siswa_tempat_lahir)
			formData.append('siswa_status', this.state.siswa_status)
			formData.append('siswa_foto', this.state.siswa_foto)
			formData.append('siswa_tanggal_lahir', this.state.siswa_tanggal_lahir)
			formData.append('siswa_username', this.state.siswa_username)
			formData.append('siswa_password', this.state.siswa_password)

		const config = {
			headers: { 'content-type': 'multipart/form-data' }
		}

		const aksi = this.props.mode === "Edit" ? "edit" : "add"

		axios.post("/siswa/" + aksi, formData, config)
			.then(response => {

				const result = response.data;

				if (!result.success) {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.info(item);
							return true
						})
					}
					else {
						Alert.info(result.message);
					}
					this.setState({ isButtonLoading: false })
				}
				else {

					Alert.success(result.message)
					this.props.history.replace("/users?l=siswa");
				}
			})
			.catch(error => {

				console.log(error)
				this.setState({ isButtonLoading: false })
				Alert.error("Gagal terhubung ke server!")
			})
	}

	handleSubmitWali() {

		this.setState({ isButtonLoading: true })

		let formData = new FormData();

		formData.append('wali_id', this.state.wali_id)
		formData.append('user_id', this.state.user_id)
		formData.append('wali_nama', this.state.wali_nama)
		formData.append('wali_alamat', this.state.wali_alamat)
		formData.append('wali_nohp', this.state.wali_nohp)
		formData.append('wali_status', this.state.wali_status)
		formData.append('wali_provinsi', this.state.wali_provinsi)
		formData.append('wali_kota', this.state.wali_kota)
		formData.append('wali_gender', this.state.wali_gender)
		formData.append('wali_tempat_lahir', this.state.wali_tempat_lahir)
		formData.append('wali_tanggal_lahir', this.state.wali_tanggal_lahir)
		formData.append('wali_foto', this.state.wali_foto)
		formData.append('wali_username', this.state.wali_username)
		formData.append('wali_password', this.state.wali_password)
		formData.append('siswa_id', this.state.wali_siswa_id)

		const config = {
			headers: { 'content-type': 'multipart/form-data' }
		}

		const aksi = this.props.mode === "Edit" ? "edit" : "add"

		axios.post("/wali/" + aksi, formData, config)
			.then(response => {

				const result = response.data;

				if (!result.success) {

					if (Array.isArray(result.message)) {

						result.message.map(item => {
							Alert.info(item)

							return true
						})
					}
					else {

						Alert.info(result.message)
					}

					this.setState({ isButtonLoading: false })
				}
				else {

					Alert.success(result.message)
					this.props.history.replace("/users?l=wali");
				}
			})
			.catch(error => {

				console.log(error)
				this.setState({ isButtonLoading: false })
				Alert.error("Gagal terhubung ke server!")
			})
	}

	handleSubmitGuru() {

		this.setState({ isButtonLoading: true })

		let formData = new FormData();

		formData.append('guru_id', this.state.guru_id)
		formData.append('user_id', this.state.user_id)
		formData.append('guru_nama', this.state.guru_nama)
		formData.append('guru_nip', this.state.guru_nip)
		formData.append('guru_rfid', this.state.guru_rfid)
		formData.append('guru_status', this.state.guru_status)
		formData.append('guru_username', this.state.guru_username)
		formData.append('guru_password', this.state.guru_password)

		const config = {
			headers: { 'content-type': 'multipart/form-data' }
		}

		const aksi = this.props.mode === "Edit" ? "edit" : "add"

		axios.post("/guru/" + aksi, formData, config)
			.then(response => {

				const result = response.data;

				if (!result.success) {

					if (Array.isArray(result.message)) {

						result.message.map(item => {
							Alert.info(item)

							return true
						})
					}
					else {

						Alert.info(result.message)
					}

					this.setState({ isButtonLoading: false })
				}
				else {

					Alert.success(result.message)
					this.props.history.replace("/users?l=guru");
				}
			})
			.catch(error => {

				console.log(error)
				this.setState({ isButtonLoading: false })
				Alert.error("Gagal terhubung ke server!")
			})
	}

	handleSubmitUser() {
		let formData = new FormData();

		const config = {
			headers: { "content-type": "multipart/form-data" }
		};

		this.setState({ isButtonLoading: true })

		const aksi = this.props.mode === "Edit" ? "edit" : "add"

		formData.append('user_id', this.state.user_id)
		formData.append('user_level', this.state.user_level)
		formData.append('user_nama', this.state.user_nama)
		formData.append('user_foto', this.state.user_foto)
		formData.append('user_username', this.state.user_username)
		formData.append('user_passw', this.state.user_passw)
		formData.append('user_status', this.state.user_status)

		axios.post("/user/" + aksi, formData, config)
			.then(response => {

				const result = response.data;

				if (!result.success) {

					if (Array.isArray(result.message)) {

						result.message.map(item => {
							Alert.info(item)

							return true
						})
					}
					else {

						Alert.info(result.message)
					}

					this.setState({ isButtonLoading: false })
				}
				else {

					Alert.success(result.message)
					this.props.history.replace("/users");
				}
			})
			.catch(error => {

				console.log(error)
				this.setState({ isButtonLoading: false })
				Alert.error("Gagal terhubung ke server!")
			})

	}

	handleSubmit() {

		switch(this.state.user_level) {

			case "siswa":
				this.handleSubmitSiswa()
				break

			case "wali":
				this.handleSubmitWali()
				break

			case "guru":
				this.handleSubmitGuru()
				break

			default:
				this.handleSubmitUser()
		}
	}

	handleDeleteFile(stateName) {

		const newState = {}

		newState[stateName] = ""

		this.setState(newState)
	}

	handleChangeDatepicker(momentObj, momentStateName, stateName) {

		const newState = {}

		newState[momentStateName]   = momentObj
		newState[stateName]         = momentObj.format('YYYY-MM-DD')

		this.setState(newState)
	}

	handleAddSiswaButton(newValue, newValueText) {

		const newDataWaliSiswaId = [
			...this.state.wali_siswa_id
		]

		const newDataWaliSiswaNama = [
			...this.state.wali_siswa_nama
		]

		newDataWaliSiswaId.splice(this.state.wali_siswa_id.length, 0, newValue)
		newDataWaliSiswaNama.splice(this.state.wali_siswa_id.length, 0, newValueText)

		this.setState({
			wali_siswa_id: newDataWaliSiswaId,
			wali_siswa_nama: newDataWaliSiswaNama
		})
	}

	setParentState(stateName, stateValue) {

		const newState = {}

		newState[stateName] = stateValue

		this.setState(newState)
	}

	onDrop(files, stateName) {

		const newState = {}

		newState[stateName] = files[0]

		this.setState(newState);
	}

	loadDataWali(){
		axios.post("/get_wali")
			.then(response => {
				return response.data.data.map(item => ({
					value	: item.wali_id,
					label	: item.user_nama
				}))
			})
			.then(result => {
				result = result.slice(0);
				result.splice(this.state.result, 0, {value:'',label:'Pilih Wali'});

				this.setState({
					dataWali: result
				})
			})
			.catch(error => {
				console.log("Wali Undefinded")
			})
	}

	loadDataKelas() {

		axios.post("/kelas")
			.then(response => {

				return response.data.data.map(item => ({
					value	: item.kelas_id,
					label	: item.kelas_nama
				}))
			})
			.then(result => {
				result = result.slice(0);
				result.splice(this.state.result, 0, {value:'',label:'Pilih Kelas'});

				this.setState({
					dataKelas: result
				})
			})
			.catch(error => {
				console.log(error)
			})
	}

	loadDataWaliEdit() {

		this.setState({ isLoading: true })

		axios.get("/wali/" + this.props.match.params.user_id)
			.then(response => {

				const result = response.data
				if (!result.data.siswa_tanggal_lahir || result.data.siswa_tanggal_lahir != null || result.data.siswa_tanggal_lahir !==  "0000-00-00" || result.data.siswa_tanggal_lahir !== '' ) {
					this.setState({
						invDate : result.data.siswa_tanggal_lahir
					})
				}else{
					this.setState({
						invDate : "2000-01-01"
					})
				}

				if (result.success) {
					const newState = {
						wali_id                     : result.data.wali_id,
						user_id                     : result.data.user_id,
						wali_nama                   : result.data.user_nama,
						wali_alamat                 : result.data.wali_alamat,
						wali_nohp                   : result.data.wali_nohp,
						wali_status                 : result.data.user_status,
						wali_provinsi               : result.data.wali_provinsi,
						wali_kota                   : result.data.wali_kota,
						wali_gender                 : result.data.wali_gender,
						wali_tempat_lahir           : result.data.wali_tempat_lahir,
						wali_tanggal_lahir          : moment(this.state.invDate).format('YYYY-MM-DD'),
						wali_tanggal_lahir_moment   : moment(this.state.invDate),
						wali_foto_exist             : result.data.user_foto,
						wali_username             	: result.data.user_username,
						wali_password             	: '',
						isLoading                   : false
					}

					// if (result.data.siswa.length > 0) {

					// 	newState.wali_siswa_id_exist    = []
					// 	newState.wali_siswa_nama_exist  = []

					// 	for (let i = 0; i < result.data.siswa.length; i++) {

					// 		newState.wali_siswa_id_exist.push(result.data.siswa[i].siswa_id)
					// 		newState.wali_siswa_nama_exist.push(result.data.siswa[i].user.user_nama)
					// 	}
					// }

					this.setState(newState)
				}
				else {

					Alert.error(result.message)
					this.setState({ isLoading: false })
				}
			})
			.catch(error => {

				console.log(error)
				this.setState({ isLoading: false })
				Alert.error("Gagal terhubung ke server!")
			})
	}

	loadDataSiswaEdit(user_id,user_level) {

		this.setState({ isLoading: true })
		const params = qs.stringify({
            user: user_id,
            level: user_level
        })

        axios.post("/get_siswa?" + params)
			.then(response => {

				const result = response.data

				if (!result.data.siswa_tanggal_lahir || result.data.siswa_tanggal_lahir != null || result.data.siswa_tanggal_lahir !==  "0000-00-00" || result.data.siswa_tanggal_lahir !== '' ) {
					this.setState({
						invDate : result.data.siswa_tanggal_lahir
					})
				}else{
					this.setState({
						invDate : "2000-01-01"
					})
				}

				if (result.success) {
					this.setState({
						user_id                    : result.data.user_id,
						kelas_id                    : result.data.kelas_id,
						siswa_id                    : result.data.siswa_id,
						siswa_nama                  : result.data.user_nama,
						siswa_nisn                  : result.data.siswa_nisn,
						siswa_rfid                  : result.data.siswa_rfid,
						wali_id                     : result.data.wali_id,
						siswa_nis                   : result.data.siswa_nis,
						siswa_tahun                 : result.data.siswa_tahun,
						siswa_provinsi              : result.data.siswa_provinsi,
						siswa_kota                  : result.data.siswa_kota,
						siswa_alamat                : result.data.siswa_alamat,
						siswa_nohp                  : result.data.siswa_nohp,
						siswa_gender                : result.data.siswa_gender,
						siswa_tempat_lahir          : result.data.siswa_tempat_lahir,
						siswa_status                : result.data.user_status,
						siswa_foto_exist            : result.data.user_foto,
						siswa_username            	: result.data.user_username,
						siswa_password            	: '',
						siswa_tanggal_lahir         : moment(this.state.invDate).format('YYYY-MM-DD'),
						siswa_tanggal_lahir_moment  : moment(this.state.invDate),
						isLoading                   : false
					})
				}
				else {

					Alert.error(result.message)
					this.setState({ isLoading: false })
				}
			})
			.catch(error => {

				console.log(error)
				this.setState({ isLoading: false })
				Alert.error("Gagal terhubung ke server!")
			})
	}

	loadDataGuruEdit() {

		this.setState({ isLoading: true })
		axios.get("/guru/" + this.props.match.params.user_id)
			.then(response => {

				const result = response.data
				if (result.success) {

					this.setState({
						user_id   : result.data.user_id,
						guru_nama : result.data.user.user_nama,
						guru_id  : result.data.guru_id,
						guru_nip  : result.data.guru_nip,
						guru_rfid : result.data.guru_rfid,
						guru_status : result.data.user.user_status,
						guru_username : result.data.user.user_username,
						guru_password : '',
						isLoading     : false
					})
				}
				else {

					Alert.error(result.message)
					this.setState({ isLoading: false })
				}
			})
			.catch(error => {

				console.log(error)
				this.setState({ isLoading: false })
				Alert.error("Gagal terhubung ke server!")
			})
	}

	componentDidMount() {

		if(localStorage.SISMART_USER_LEVEL !=='administrator'){
			this.props.history.replace("/dashboard");
		}

		const urlParams = queryString.parse(this.props.location.search);
		let newLev = [];
		switch (urlParams.l) {
			case "siswa":
				newLev = [
					{ key: "siswa", value: "Siswa" }
				]
				this.setState({user_level:"siswa", dataLevel:newLev})
				break;
			case "wali":
				newLev = [
					{ key: "wali", value: "Wali" }
				]
				this.setState({user_level:"wali", dataLevel:newLev})
				break;
			case "guru":
				newLev = [
					{ key: "guru", value: "Guru" }
				]
				this.setState({user_level:"guru", dataLevel:newLev})
				break;
			default:
				newLev = [
					{ key: "administrator", value: "Administrator" },
					{ key: "admin_konten", value: "Admin Konten" },
					{ key: "akademik", value: "Akademik" },
					{ key: "keuangan", value: "Keuangan" }
				]
				this.setState({user_level:"administrator", dataLevel:newLev})
		}

		this.loadDataKelas()
		this.loadDataWali()


		if (this.props.mode === 'Edit') {

			const urlParams = this.props.location.pathname;
			const surlParams = urlParams.split('/');

			const user_id=surlParams[3]
			const user_level=surlParams[2]

			switch (surlParams[2]) {
				case "siswa":
					this.setState({user_level:"siswa"})
					this.loadDataSiswaEdit(user_id,user_level);
					break;
				case "wali":
					this.setState({user_level:"wali"})
					this.loadDataWaliEdit()
					break;
				case "guru":
					this.setState({user_level:"guru"})
					this.loadDataGuruEdit();
					break;
				default:
					this.setState({ isLoading: true })

			axios.get("/user/" + this.props.match.params.user_id)
				.then(response => {

					const result = response.data;

					if (result.success) {

						const newState = {
							user_id         : result.data.user_id,
							user_level      : result.data.user_level,
							user_nama       : result.data.user_nama,
							user_foto       : result.data.user_foto,
							user_username   : result.data.user_username,
							user_status     : result.data.user_status,
							isLoading       : false,
						}

						if (result.data.user_level === "wali") {

							newState.wali_id = result.data.detail.wali_id
						}
						else if (result.data.user_level === "siswa") {

							newState.siswa_id = result.data.detail.siswa_id
							newState.wali_id  = result.data.detail.wali_id
						}

						this.setState(newState)
					}
					else {

						Alert.error(result.message)
						this.setState({ isLoading: false })
					}
				})
				.catch(error => {

					console.log(error)
					this.setState({ isLoading: false })
					Alert.error("Gagal terhubung ke server!")
				})
			}
		}else{
			const urlParams = queryString.parse(this.props.location.search);
			switch (urlParams.l) {
				case "siswa":
					this.setState({user_level:"siswa"})
					break;
				case "wali":
					this.setState({user_level:"wali"})
					break;
				case "guru":
					this.setState({user_level:"guru"})
					break;
				default:
					this.setState({user_level:"administrator"})
			}
		}
	}

	render() {

		return (
			<div className="col-sm-12">
				<div className="card">
					<div className="card-header">
						{this.props.mode} Pengguna
					</div>
					<div className="card-block">
					{
						this.state.isLoading ? 'Memuat Data...' : (
							<div className="form-horizontal animated fadeIn">

							<VerifikasiModal
									isShow={this.state.isModalVerifikasi}
									toggleModalVerifikasi={this.toggleModalVerifikasi}
									modalHeaderText="Verifikasi Data Wali"
									modalBodyText="Apakah benar data ini wali murid dan saudara anda...?"
									dataWaliSiswa = {this.state.dataWaliSiswa.length > 0 ? this.state.dataWaliSiswa : []}
									modalSubmitText="Ya" />


							<FormModalWali
								isShow={this.state.isModalWali}
								toggleModalWali={this.toggleModalWali}
								handleSubmit={this.handleSubmitChangePass}
								modalHeaderText="Form Wali Murid"
								modalBodyText="Anda yakin ingin menghapus data ini?"
								modalSubmitText="Ya" />

								<FormModalKelas
									isShow={this.state.isModalKelas}
									toggleModalKelas={this.toggleModalKelas}
									handleSubmit={this.handleSubmitChangePass}
									modalHeaderText="Form Wali Murid"
									modalBodyText="Anda yakin ingin menghapus data ini?"
									modalSubmitText="Ya" />

								<div>
									<div className="form-group row">
										<label className="col-md-2 form-control-label">User Level</label>
										<div className="col-md-10">
											<FormDropdown
												name="user_level"
												items={this.state.dataLevel}
												onChange={this.handleChange}
												disabled={this.props.mode === "Edit"}
												value={this.state.user_level}
											/>
										</div>
									</div>

									{
										this.state.user_level == "siswa" ?
										<div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">Wali</label>
												<div className="col-md-7">
													<Select
														name="wali_id"
														simpleValue
														value={this.state.wali_id.toString()}
														clearable={false}
														placeholder={"Pilih"}
														onChange={text =>
															this.handleChangeMultiSelect("wali_id", text)
														}
														options={this.state.dataWali}
														isLoading={this.state.isLoading}
													/>

												</div>
												<div className="col-md-3">
													<button
														onClick={() => {
															this.toggleModalWali();
																}}
														className="btn btn-danger btn-sm">
														Tambah Wali
													</button>
												</div>
											</div>

											<div className="form-group row">
												<label className="col-md-2 form-control-label">Kelas</label>
												<div className="col-md-7">
													<Select
														name="kelas_id"
														simpleValue
														value={this.state.kelas_id.toString()}
														clearable={false}
														placeholder={"Pilih"}
														onChange={text =>
															this.handleChangeMultiSelect("kelas_id", text)
														}
														options={this.state.dataKelas}
														isLoading={this.state.isLoading}
													/>
												</div>
												<div className="col-md-3">
													<button
														onClick={() => {
															this.toggleModalKelas();
																}}
														className="btn btn-danger btn-sm">
														Tambah Kelas
													</button>
												</div>
											</div>

											<div className="form-group row">
											<label className="col-md-2 form-control-label">Nama Lengkap Siswa</label>
											<div className="col-md-10">
												<input
													name="siswa_nama"
													type="text"
													className="form-control"
													placeholder="Nama Lengkap"
													onChange={this.handleChange}
													value={this.state.siswa_nama} />
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">NISN</label>
											<div className="col-md-10">
												<input
													name="siswa_nisn"
													type="text"
													className="form-control"
													placeholder="NISN"
													onChange={this.handleChange}
													value={this.state.siswa_nisn} />
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												No. Induk Siswa <br />
												<small className="text-muted">
													<table>
														<tr>
															<td style={{verticalAlign: "top"}}><i className="fa fa-info-circle"></i>{" "}</td>
															<td>Digunakan sebagai username dan password default siswa</td>
														</tr>
													</table>
												</small>
											</label>
											<div className="col-md-10">
												<input
													name="siswa_nis"
													type="text"
													className="form-control"
													placeholder="Nomor Induk Siswa"
													onChange={this.handleChange}
													value={this.state.siswa_nis} />
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">Tahun Angkatan</label>
											<div className="col-md-10">
												<input
													name="siswa_tahun"
													type="number"
													className="form-control"
													placeholder="Tahun Angkatan Siswa"
													onChange={this.handleChange}
													maxLength={4}
													value={this.state.siswa_tahun} />
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">Alamat</label>
											<div className="col-md-10">
												<textarea
													name="siswa_alamat"
													className="form-control"
													placeholder="Alamat Lengkap"
													onChange={this.handleChange}
													value={this.state.siswa_alamat} />
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">Kota</label>
											<div className="col-md-10">
												<input
													name="siswa_kota"
													type="text"
													className="form-control"
													placeholder="Alamat Kota"
													onChange={this.handleChange}
													value={this.state.siswa_kota} />
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">Provinsi</label>
											<div className="col-md-10">
												<input
													name="siswa_provinsi"
													type="text"
													className="form-control"
													placeholder="Alamat Provinsi"
													onChange={this.handleChange}
													value={this.state.siswa_provinsi} />
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">No. HP</label>
											<div className="col-md-10">
												<input
													name="siswa_nohp"
													type="number"
													className="form-control"
													placeholder="No. Handphone"
													onChange={this.handleChange}
													value={this.state.siswa_nohp} />
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">Jenis Kelamin</label>
											<div className="col-md-10">
												<FormDropdown
													name="siswa_gender"
													items={jekel}
													onChange={this.handleChange}
													value={this.state.siswa_gender} />
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">Tempat Lahir</label>
											<div className="col-md-10">
												<input
													name="siswa_tempat_lahir"
													type="text"
													className="form-control"
													placeholder="Tempat Lahir"
													onChange={this.handleChange}
													value={this.state.siswa_tempat_lahir} />
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">Tanggal Lahir</label>
											<div className="col-md-10">
												<DatePicker
													selected={this.state.siswa_tanggal_lahir_moment}
													onChange={(momentObj) => {
														this.handleChangeDatepicker(momentObj, "siswa_tanggal_lahir_moment", "siswa_tanggal_lahir")
													}}
													peekNextMonth
													showMonthDropdown
													showYearDropdown
													dropdownMode="select"
												/>
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">REF ID KARTU</label>

											{localStorage.SISMART_USER_USERNAME === 'root@master.com' ? (
												<div className="col-md-10">
													<input
														name="siswa_rfid"
														type="number"
														className="form-control"
														placeholder="Masukkan REF ID Kartu yang valid"
														onChange={this.handleChange}
														value={this.state.siswa_rfid} />
												</div>
											):(
												<div className="col-md-10">
													<input
														name="siswa_rfid"
														type="number"
														className="form-control"
														placeholder="Masukkan REF ID Kartu yang valid"
														onChange={this.handleChange}
														disabled={this.props.mode === "Edit"}
														value={this.state.siswa_rfid} />
												</div>
											)}

										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Username
											</label>
											<div className="col-md-10">
												<input
													name="siswa_username"
													type="text"
													disabled={this.props.mode === "Edit"}
													className="form-control"
													placeholder="Username untuk login"
													onChange={this.handleChange}
													value={this.state.siswa_username} />
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Password
											</label>
											<div className="col-md-10">
												<input
													name="siswa_password"
													type="password"
													className="form-control"
													placeholder={this.props.mode === 'Edit' ? "Password (Biarkan kosong jika tidak ingin mengganti)" : "Password"}
													onChange={this.handleChange}
													value={this.state.siswa_password} />
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">Status Aktif</label>
											<div className="col-md-10">
												<FormDropdown
													name="siswa_status"
													items={status_aktif}
													onChange={this.handleChange}
													value={this.state.siswa_status} />
											</div>
										</div>
										{
											this.props.mode === "Edit" &&
												(
													<div className="form-group row">
														<label className="col-md-2 form-control-label">Foto Siswa</label>
														<div className="col-md-10">
															<img
																src={FOTO_SISWA_HOST + this.state.siswa_foto_exist}
																alt=""
																style={{ width: "300px" }} />
														</div>
													</div>
												)
										}
										<div className="form-group row">
											<label className="col-md-12 form-control-label">{this.props.mode === "Edit" && "Ganti"} File foto Siswa</label>
											<div className="col-md-12">
												<Dropzone
													onDrop={(e) => this.onDrop(e, "siswa_foto")}
													multiple={false}
													style={{
														width: "100%",
														height: "auto",
														border: "2px dashed #e9e9e9",
														padding: "20px 30px",
														color: "#888",
														cursor: "pointer",
														textAlign: "center",
														marginBottom: "15px"
													}}
												>
													Klik atau drop file disini untuk mengupload file
												</Dropzone>

												{
													this.state.siswa_foto !== "" &&
													<span>
														{this.state.siswa_foto.name} {" "}
														<button
															title="Hapus"
															className="btn btn-sm btn-danger"
															onClick={() => this.handleDeleteFile("siswa_foto")}
															type="button"
														>
															<i className="fa fa-remove"></i>
														</button>
													</span>
												}
											</div>
											</div>

										</div>

									:""}

									{
										this.state.user_level == "administrator" ?

										<div>
											<div className="form-group row">
										<label className="col-md-2 form-control-label">Nama Lengkap</label>
										<div className="col-md-10">
											<input
												name="user_nama"
												type="text"
												className="form-control"
												placeholder="Nama Lengkap"
												onChange={this.handleChange}
												value={this.state.user_nama} />
										</div>
									</div>
									<div className="form-group row">
										<label className="col-md-2 form-control-label">
											Username
										</label>
										<div className="col-md-10">
											<input
												name="user_username"
												type="text"
												className="form-control"
												placeholder="Username untuk login"
												onChange={this.handleChange}
												value={this.state.user_username} />
										</div>
									</div>
									<div className="form-group row">
										<label className="col-md-2 form-control-label">
											Password
										</label>
										<div className="col-md-10">
											<input
												name="user_passw"
												type="password"
												className="form-control"
												placeholder={this.props.mode === 'Edit' ? "Password (Biarkan kosong jika tidak ingin mengganti)" : "Password"}
												disabled={this.state.user_username === "root@master.com"}
												onChange={this.handleChange}
												value={this.state.user_passw} />
										</div>
									</div>
									<div className="form-group row">
										<label className="col-md-2 form-control-label">Status Akun</label>
										<div className="col-md-10">
											<FormDropdown
												name="user_status"
												items={status_aktif}
												onChange={this.handleChange}
												value={this.state.user_status} />
										</div>
									</div>
										</div>
										:""}


									{
										this.state.user_level == "admin_konten" ?

										<div>
											<div className="form-group row">
										<label className="col-md-2 form-control-label">Nama Lengkap</label>
										<div className="col-md-10">
											<input
												name="user_nama"
												type="text"
												className="form-control"
												placeholder="Nama Lengkap"
												onChange={this.handleChange}
												value={this.state.user_nama} />
										</div>
									</div>
									<div className="form-group row">
										<label className="col-md-2 form-control-label">
											Username
										</label>
										<div className="col-md-10">
											<input
												name="user_username"
												type="text"
												className="form-control"
												placeholder="Username untuk login"
												onChange={this.handleChange}
												value={this.state.user_username} />
										</div>
									</div>
									<div className="form-group row">
										<label className="col-md-2 form-control-label">
											Password
										</label>
										<div className="col-md-10">
											<input
												name="user_passw"
												type="password"
												className="form-control"
												placeholder={this.props.mode === 'Edit' ? "Password (Biarkan kosong jika tidak ingin mengganti)" : "Password"}
												onChange={this.handleChange}
												value={this.state.user_passw} />
										</div>
									</div>
									<div className="form-group row">
										<label className="col-md-2 form-control-label">Status Akun</label>
										<div className="col-md-10">
											<FormDropdown
												name="user_status"
												items={status_aktif}
												onChange={this.handleChange}
												value={this.state.user_status} />
										</div>
									</div>
										</div>
										:""}


									{
										this.state.user_level == "akademik" ?

										<div>
											<div className="form-group row">
										<label className="col-md-2 form-control-label">Nama Lengkap</label>
										<div className="col-md-10">
											<input
												name="user_nama"
												type="text"
												className="form-control"
												placeholder="Nama Lengkap"
												onChange={this.handleChange}
												value={this.state.user_nama} />
										</div>
									</div>
									<div className="form-group row">
										<label className="col-md-2 form-control-label">
											Username
										</label>
										<div className="col-md-10">
											<input
												name="user_username"
												type="text"
												className="form-control"
												placeholder="Username untuk login"
												onChange={this.handleChange}
												value={this.state.user_username} />
										</div>
									</div>
									<div className="form-group row">
										<label className="col-md-2 form-control-label">
											Password
										</label>
										<div className="col-md-10">
											<input
												name="user_passw"
												type="password"
												className="form-control"
												placeholder={this.props.mode === 'Edit' ? "Password (Biarkan kosong jika tidak ingin mengganti)" : "Password"}
												onChange={this.handleChange}
												value={this.state.user_passw} />
										</div>
									</div>
									<div className="form-group row">
										<label className="col-md-2 form-control-label">Status Akun</label>
										<div className="col-md-10">
											<FormDropdown
												name="user_status"
												items={status_aktif}
												onChange={this.handleChange}
												value={this.state.user_status} />
										</div>
									</div>
										</div>
										:""}


									{
										this.state.user_level == "keuangan" ?

										<div>
											<div className="form-group row">
										<label className="col-md-2 form-control-label">Nama Lengkap</label>
										<div className="col-md-10">
											<input
												name="user_nama"
												type="text"
												className="form-control"
												placeholder="Nama Lengkap"
												onChange={this.handleChange}
												value={this.state.user_nama} />
										</div>
									</div>
									<div className="form-group row">
										<label className="col-md-2 form-control-label">
											Username
										</label>
										<div className="col-md-10">
											<input
												name="user_username"
												type="text"
												className="form-control"
												placeholder="Username untuk login"
												onChange={this.handleChange}
												value={this.state.user_username} />
										</div>
									</div>
									<div className="form-group row">
										<label className="col-md-2 form-control-label">
											Password
										</label>
										<div className="col-md-10">
											<input
												name="user_passw"
												type="password"
												className="form-control"
												placeholder={this.props.mode === 'Edit' ? "Password (Biarkan kosong jika tidak ingin mengganti)" : "Password"}
												onChange={this.handleChange}
												value={this.state.user_passw} />
										</div>
									</div>
									<div className="form-group row">
										<label className="col-md-2 form-control-label">Status Akun</label>
										<div className="col-md-10">
											<FormDropdown
												name="user_status"
												items={status_aktif}
												onChange={this.handleChange}
												value={this.state.user_status} />
										</div>
									</div>
										</div>
										:""}

									{
										this.state.user_level == "guru" ?

										<div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">Nama Lengkap Guru</label>
											<div className="col-md-10">
												<input
													name="guru_nama"
													type="text"
													className="form-control"
													placeholder="Nama Lengkap"
													onChange={this.handleChange}
													value={this.state.guru_nama} />
											</div>
										</div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">NIP Guru</label>
												<div className="col-md-10">
													<input
														name="guru_nip"
														type="text"
														className="form-control"
														placeholder="NIP"
														onChange={this.handleChange}
														value={this.state.guru_nip} />
												</div>
											</div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">REF ID KARTU</label>
												{localStorage.SISMART_USER_USERNAME === 'root@master.com' ? (

													<div className="col-md-10">
														<input
															name="guru_rfid"
															type="number"
															className="form-control"
															placeholder="Masukkan REF ID Kartu yang valid"
															onChange={this.handleChange}
															value={this.state.guru_rfid} />
													</div>
													):(

													<div className="col-md-10">
														<input
															name="guru_rfid"
															type="number"
															className="form-control"
															placeholder="Masukkan REF ID Kartu yang valid"
															onChange={this.handleChange}
															disabled={this.props.mode === "Edit"}
															value={this.state.guru_rfid} />
													</div>
												)}

											</div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">
													Username
												</label>
												<div className="col-md-10">
													<input
														name="guru_username"
														type="text"
														className="form-control"
														placeholder="Username untuk login"
														onChange={this.handleChange}
														value={this.state.guru_username} />
												</div>
											</div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">
													Password
												</label>
												<div className="col-md-10">
													<input
														name="guru_password"
														type="password"
														className="form-control"
														placeholder={this.props.mode === 'Edit' ? "Password (Biarkan kosong jika tidak ingin mengganti)" : "Password"}
														onChange={this.handleChange}
														value={this.state.guru_password} />
												</div>
											</div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">Status Aktif</label>
												<div className="col-md-10">
													<FormDropdown
														name="guru_status"
														items={status_aktif}
														onChange={this.handleChange}
														value={this.state.guru_status} />
												</div>
											</div>
										</div>
										:""}

									{
										this.state.user_level == "wali" ?

										<div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">Nama Lengkap Wali</label>
												<div className="col-md-10">
													<input
														name="wali_nama"
														type="text"
														className="form-control"
														placeholder="Nama Lengkap"
														onChange={this.handleChange}
														value={this.state.wali_nama} />
												</div>
											</div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">
													No. HP <br />
													<small className="text-muted">
														<table>
															<tr>
																<td style={{ verticalAlign: "top" }}><i className="fa fa-info-circle"></i>{" "}</td>
																<td>Digunakan sebagai username dan password default wali</td>
															</tr>
														</table>
													</small>
												</label>
												<div className="col-md-10">
													<input
														name="wali_nohp"
														type="number"
														className="form-control"
														placeholder="No. Handphone"
														onChange={this.handleChange}
														value={this.state.wali_nohp} />
												</div>
											</div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">Alamat</label>
												<div className="col-md-10">
													<textarea
														name="wali_alamat"
														className="form-control"
														placeholder="Alamat Lengkap"
														onChange={this.handleChange}
														value={this.state.wali_alamat} />
												</div>
											</div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">Kota</label>
												<div className="col-md-10">
													<input
														name="wali_kota"
														type="text"
														className="form-control"
														placeholder="Alamat Kota"
														onChange={this.handleChange}
														value={this.state.wali_kota} />
												</div>
											</div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">Provinsi</label>
												<div className="col-md-10">
													<input
														name="wali_provinsi"
														type="text"
														className="form-control"
														placeholder="Alamat Provinsi"
														onChange={this.handleChange}
														value={this.state.wali_provinsi} />
												</div>
											</div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">Jenis Kelamin</label>
												<div className="col-md-10">
													<FormDropdown
														name="wali_gender"
														items={jekel}
														onChange={this.handleChange}
														value={this.state.wali_gender} />
												</div>
											</div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">Tempat Lahir</label>
												<div className="col-md-10">
													<input
														name="wali_tempat_lahir"
														type="text"
														className="form-control"
														placeholder="Tempat Lahir"
														onChange={this.handleChange}
														value={this.state.wali_tempat_lahir} />
												</div>
											</div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">Tanggal Lahir</label>
												<div className="col-md-10">
													<DatePicker
														selected={this.state.wali_tanggal_lahir_moment}
														onChange={(momentObj) => {
															this.handleChangeDatepicker(momentObj, "wali_tanggal_lahir_moment", "wali_tanggal_lahir")
														}}
														peekNextMonth
														showMonthDropdown
														showYearDropdown
														dropdownMode="select"
													/>
												</div>
											</div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">
													Username
												</label>
												<div className="col-md-10">
													<input
														name="wali_username"
														type="text"
														className="form-control"
														placeholder="Username untuk login"
														onChange={this.handleChange}
														value={this.state.wali_username} />
												</div>
											</div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">
													Password
												</label>
												<div className="col-md-10">
													<input
														name="wali_password"
														type="password"
														className="form-control"
														placeholder={this.props.mode === 'Edit' ? "Password (Biarkan kosong jika tidak ingin mengganti)" : "Password"}
														onChange={this.handleChange}
														value={this.state.wali_password} />
												</div>
											</div>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">Status Aktif</label>
												<div className="col-md-10">
													<FormDropdown
														name="wali_status"
														items={status_aktif}
														onChange={this.handleChange}
														value={this.state.wali_status} />
												</div>
											</div>
											{
												this.props.mode === "Edit" &&
												(
													<div className="form-group row">
														<label className="col-md-2 form-control-label">Foto Wali</label>
														<div className="col-md-10">
															<img
																src={FOTO_WALI_HOST + this.state.wali_foto_exist}
																alt=""
																style={{ width: "300px" }} />
														</div>
													</div>
												)
											}
											<div className="form-group row">
												<label className="col-md-12 form-control-label">{this.props.mode === "Edit" && "Ganti"} File foto Wali</label>
												<div className="col-md-12">
													<Dropzone
														onDrop={(e) => this.onDrop(e, "wali_foto")}
														multiple={false}
														style={{
															width: "100%",
															height: "auto",
															border: "2px dashed #e9e9e9",
															padding: "20px 30px",
															color: "#888",
															cursor: "pointer",
															textAlign: "center",
															marginBottom: "15px"
														}}
													>
														Klik atau drop file disini untuk mengupload file
													</Dropzone>

													{
														this.state.wali_foto !== "" &&
														<span>
															{this.state.wali_foto.name} {" "}
															<button
																title="Hapus"
																className="btn btn-sm btn-danger"
																onClick={() => this.handleDeleteFile("wali_foto")}
																type="button"
															>
																<i className="fa fa-remove"></i>
															</button>
														</span>
													}
												</div>
											</div>
										</div>

										:""}


								</div>
							</div>
						)
					}
					</div>
					<div className="card-footer">
						<button
							type="button"
							className="btn btn-md btn-primary"
							disabled={this.state.isButtonLoading && "disabled"}
							onClick={this.handleSubmit}
						>
							{this.state.isButtonLoading ? "Loading" : "Simpan"}
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default Forms;



// WEBPACK FOOTER //
// ./src/views/Users/Forms.js